import { WatchMockService } from './../../../utils/mock-service/watch-mock.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';


@Component({
  selector: 'app-watch-edit',
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule],
  templateUrl: './watch-edit.component.html',
  styleUrl: './watch-edit.component.scss'
})
export class WatchEditComponent implements OnInit {
  watchForm!: FormGroup;
  watchId!: number;

  constructor(
    private fb: FormBuilder,
    private watchMockService: WatchMockService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.watchId = +this.route.snapshot.paramMap.get('id')!;
    this.watchMockService.getWatchById(this.watchId).subscribe((watch) => {
      this.watchForm = this.fb.group({
        name: [watch?.name, Validators.required],
        brand: [watch?.brand.name, Validators.required],
        price: [watch?.price, Validators.required],
        condition: [watch?.condition, Validators.required],
        marketStatus: [watch?.marketStatus, Validators.required],
        description: [watch?.description, Validators.required],
        images: [watch?.images, Validators.required]
      });
    });
  }

  onSubmit(): void {
    if (this.watchForm.valid) {
      this.watchMockService.updateWatch(this.watchId, this.watchForm.value).subscribe(() => {
        this.router.navigate(['/market']);
      });
    }
  }


}
